import { cx } from '@emotion/css';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import { Autocomplete, Chip } from '@mui/material';
import React, { useState } from 'react';
import isValidEmail from '../../../../utils/isValidEmail';
import { InputField } from '../InputField';
import { useStyles } from './ChipField.styles';
const SUBMIT_BUTTON_CODES = ['Space', 'Enter', 'NumpadEnter'];
export function ChipField(props) {
    const { clearable, id, onChange, onInputValidation, placeholder, type = 'text', value, title, className, showAdd, error, helperText, isValid: providedIsValid, } = props;
    const classes = useStyles();
    const [inputValue, setInputValue] = useState('');
    function validateElement(element) {
        let isValid = true;
        if (providedIsValid) {
            isValid = providedIsValid(element);
        }
        else if (type === 'email') {
            isValid = isValidEmail(element);
        }
        return isValid;
    }
    function isChipAlreadyAdded(currentInputValue) {
        return value.includes(currentInputValue);
    }
    function checkIfChipsAreValid(currentValue) {
        return currentValue.map((email) => validateElement(email)).every(Boolean);
    }
    function checkIfInputIsValid(currentValue) {
        return currentValue.length > 0 && checkIfChipsAreValid(currentValue);
    }
    function shouldSubmitNewChip(currentInputValue, buttonCode) {
        return (currentInputValue !== '' &&
            !isChipAlreadyAdded(currentInputValue) &&
            (buttonCode === null || SUBMIT_BUTTON_CODES.includes(buttonCode)));
    }
    function shouldRemoveLastChip(currentInputValue, buttonCode) {
        return currentInputValue === '' && buttonCode === 'Backspace' && value.length > 0;
    }
    function submitNewChip(currentInputValue) {
        handleChange([...value, currentInputValue]);
        setInputValue('');
    }
    function removeLastChip() {
        handleChange(value.slice(0, -1));
    }
    function handleInputChange(e) {
        const trimmedValue = e.target.value.trim();
        setInputValue(trimmedValue);
        if (trimmedValue !== '') {
            const isCurrentInputValid = validateElement(trimmedValue) && checkIfChipsAreValid(value);
            onInputValidation === null || onInputValidation === void 0 ? void 0 : onInputValidation(isCurrentInputValid);
        }
    }
    function handleKeyDown(e) {
        const target = e.target;
        const trimmedValue = target.value.trim();
        if (shouldSubmitNewChip(trimmedValue, e.code)) {
            submitNewChip(trimmedValue);
            return;
        }
        if (shouldRemoveLastChip(trimmedValue, e.code)) {
            removeLastChip();
            return;
        }
    }
    function handleBlur(e) {
        const trimmedValue = e.target.value.trim();
        if (shouldSubmitNewChip(trimmedValue, null)) {
            submitNewChip(trimmedValue);
        }
    }
    function handleChange(currentValue) {
        onChange(currentValue);
        const isInputValid = checkIfInputIsValid(currentValue);
        if (onInputValidation) {
            onInputValidation(isInputValid);
        }
    }
    function handleAdd() {
        const trimmedValue = inputValue.trim();
        if (shouldSubmitNewChip(trimmedValue, null)) {
            submitNewChip(trimmedValue);
        }
    }
    function renderTags(valueElements) {
        return valueElements.map((element) => {
            const isValid = validateElement(element);
            return (React.createElement(Chip, { className: cx(classes.chip, isValid ? classes.chipCorrect : classes.chipError), key: element, label: element, deleteIcon: React.createElement(ClearIcon, { className: classes.clearIcon }), onDelete: () => {
                    const currentValueWithRemovedOption = [...value].filter((val) => val !== element);
                    handleChange(currentValueWithRemovedOption);
                } }));
        });
    }
    function renderInput(params) {
        return (React.createElement(InputField, { id: params.id, disabled: params.disabled, fullWidth: params.fullWidth, className: classes.textField, value: params.inputProps.value, textFieldProps: {
                variant: 'outlined',
                inputProps: Object.assign(Object.assign({}, params.inputProps), { value: inputValue }),
                InputProps: Object.assign(Object.assign({}, params.InputProps), { onChange: handleInputChange, onBlur: handleBlur }),
                InputLabelProps: params.InputLabelProps,
            }, placeholder: value.length ? '' : placeholder, customEndAdornment: showAdd && !clearable ? React.createElement(AddIcon, { className: classes.addIcon, onClick: handleAdd }) : undefined, error: error, helperText: helperText }));
    }
    return (React.createElement("div", { id: id, className: className },
        title && React.createElement("div", { className: classes.title }, title),
        React.createElement(Autocomplete, { value: value, options: [], defaultValue: [], disableClearable: !clearable, onKeyDown: handleKeyDown, onBlur: handleBlur, renderTags: renderTags, renderInput: renderInput, freeSolo: true, multiple: true })));
}
//# sourceMappingURL=ChipField.js.map